/**
 * == Controller: ClientUserProfileController
 *
 * Placeholder extension point for client user profile pages. Currently relies
 * on shared logic from `PlatformBaseController`, providing structure for future
 * profile-specific behaviours.
 */
import PlatformBaseController from "./platform_base_controller"

// Main controller for handling project/document list filtering
export default class extends PlatformBaseController {

}
